import React, { FC, ReactElement, useContext } from 'react'
import { useFormContext, UseFormMethods } from '../../../Vendor/react-hook-form/dist/index.ie11'
import { SelfProvisioning as SelfProvisioningLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { IsVarEmpty, isVarNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import Button from '../../Common/Components/Button'
import ModalExitPromptContext, { ModalExitPromptType } from '../../Common/Components/Modal/ModalExitPromptContext'
import { LanguageContext } from '../../Common/Contexts'
import { CommonFormContext, FormContextType } from '../../Common/Contexts/CommonFormContext'
import { ModalContext, ModalContextType } from '../../Common/Contexts/ModalContext'
import { SelfProvisioningContext, SelfProvisioningContextType } from '../Contexts/SelfProvisioningContext'
import { SelfProvisioningInitalDataFormState } from '../../../NonReact/common/Types/SelfProvisioning/SelfProvisioningTypes'

type Props = {
    showRightSideButton?: boolean
    rightSideButtonType: 'button' | 'submit'
    rightSideButtonClick?: (event?: React.MouseEvent) => void
    rightSideButtonLabel: ReactElement | string
    rightButtonDisabled?: boolean
}

export const FooterActions: FC<Props> = ({
    showRightSideButton,
    rightSideButtonLabel,
    rightSideButtonType,
    rightSideButtonClick,
    rightButtonDisabled
}: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    const { displayExitPrompt }: ModalExitPromptType = useContext(ModalExitPromptContext)
    const { closeModal }: ModalContextType = useContext(ModalContext)
    const {
        viewState: [view],
        deleteableTelSysState: [deleteableTelSys],
        deleteablePartitionState: [deleteablePartition]
    }: SelfProvisioningContextType = useContext(SelfProvisioningContext)
    const commonForm: Nullable<FormContextType> = useContext(CommonFormContext)

    const formContext: Nullable<UseFormMethods<SelfProvisioningInitalDataFormState>> = useFormContext()

    const handleCancel = (): void => {
        if (isVarNotEmpty(deleteableTelSys) || isVarNotEmpty(deleteablePartition) || commonForm?.isTouched) {
            displayExitPrompt()
        } else {
            closeModal()
        }
    }

    return (
        <div className='sp-footer-actions'>
            <Button
                type='button'
                label={language.get(SelfProvisioningLanguage.SelfProvisioning_FooterActions_Cancel)}
                onClick={handleCancel}
                isOutlined
            />

            <span className={`view-dots view-${view}`}>
                <span className='view-dot'></span>
                <span className='view-dot'></span>
                <span className='view-dot'></span>
                <span className='view-dot'></span>
                <span className='view-dot'></span>
            </span>

            {showRightSideButton === true ? (
                <Button
                    isDisabled={
                        (!IsVarEmpty(formContext?.formState?.isValid) && !formContext.formState.isValid) ||
                        rightButtonDisabled
                    }
                    label={rightSideButtonLabel}
                    type={rightSideButtonType}
                    onClick={rightSideButtonClick}
                />
            ) : (
                <div></div>
            )}
        </div>
    )
}
